// Copyright (c) 2022 Deere & Company

import ClosingAccountAccordion from './closing-account-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.createTransfer,
    accountIndex: state.tcsm.wip.closingAccountIndex,
    closingAccountChanges: state.tcsm.wip.closingAccountChanges,
    closingAccountSearchFilters: state.tcsm.wip.closingAccountSearchFilters,
    isModalVisible: state.createTransfer.dealerSearchModal.isVisible,
    length: state.tcsm.wip.closingAccountLength,
    selectedDealers: state.tcsm.wip.wipFacets.dealers
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClosingAccountAccordion);



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/closing-account/index.js